import { /*Badge,*/ Body, Button, Card, CenteredBox, ElementHighlight, Expertise, useTooltipSeries } from '../widgets'
import { indexFromValue, practices, valueColors, valueTextColors } from '../../lookups'
import { useRef } from 'react'
import { useBreakpoints } from '@10000/react'

export const PracticeResultsCard = ({ practice, value, change, /*rank,*/ onClick, onClose, displayMode }) => {
  const { name } = practices[practice] || {}
  const learnMore = useRef()
  const { constrained } = useBreakpoints()
  const { tip } = useTooltipSeries()

  return (
    <>
      <Card
        column
        width={335}
        rotate={8}
        background={valueColors[indexFromValue(value)]}
        textColor={valueTextColors[indexFromValue(value)]}
        p={24}
        gap={16}
        onClose={(!displayMode && tip !== 4) && onClose}
        onClick={e => e.stopPropagation()}
        ref={learnMore}
      >
        <Body alt bold>
          {name}
        </Body>

        <CenteredBox fullWidth>
          <CenteredBox width="50%">
            <Expertise value={value} change={change} color={valueTextColors[Math.floor(value)]} />
          </CenteredBox>
          {/*{rank &&*/}
          {/*  <Box width="50%" justifyContent="flex-end" pr={16}>*/}
          {/*    <Badge rank={rank} mode="subset" />*/}
          {/*  </Box>*/}
          {/*}*/}
        </CenteredBox>

        {!displayMode &&
          <Button onClick={onClick}>
            Learn more
          </Button>
        }
      </Card>

      {constrained && <ElementHighlight
        order={4}
        target={learnMore}
        pointDirection="down"
        nextOnFinish
      />}
    </>
  )
}